module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/410.090bba8e.png";